import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { getUserPermissions } from 'dashboard/helper/permissionsHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import {
  canAccessKanban,
  canManageDeals,
  canManageKanban,
  canViewKanbanAnalytics,
  kanbanOwnDealsOnly,
} from 'dashboard/helper/kanbanPermissions';

// Os três degraus do Kanban pro usuário logado na conta atual. Lê os getters
// raiz (não a rota) pra funcionar em painel de conversa e em spec com store
// mínimo. Substitui o `useAdmin` dentro do Kanban: papel personalizado com
// kanban_manage nunca é "administrator", mas gere o quadro.
export function useKanbanPermissions() {
  const currentUser = useMapGetter('getCurrentUser');
  const accountId = useMapGetter('getCurrentAccountId');

  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  const permissions = computed(() =>
    getUserPermissions(currentUser.value, accountId.value)
  );
  const canAccess = computed(() => canAccessKanban(permissions.value));

  return {
    canAccessKanban: canAccess,
    // Kanban LIGADO na conta E o usuário pode ver: é o que decide mostrar
    // qualquer pedaço do Kanban fora do próprio Kanban (lateral da conversa).
    // Só a permissão não basta — atendente sem papel personalizado tem
    // `kanban_access` por padrão em TODA conta, inclusive nas que não têm a
    // feature, e a API responde 403 (RUBY-RAILS-8F, conta 325, 2026-09-30).
    kanbanAvailable: computed(
      () =>
        canAccess.value &&
        Boolean(
          isFeatureEnabledonAccount.value?.(
            accountId.value,
            FEATURE_FLAGS.KANBAN
          )
        )
    ),
    canViewKanbanAnalytics: computed(() =>
      canViewKanbanAnalytics(permissions.value)
    ),
    canManageDeals: computed(() => canManageDeals(permissions.value)),
    canManageKanban: computed(() => canManageKanban(permissions.value)),
    // Papel "só os cards que atende" (Deals::Visibility): o quadro avisa o
    // recorte em vez de parecer vazio/quebrado.
    ownDealsOnly: computed(() => kanbanOwnDealsOnly(permissions.value)),
  };
}
